import PropTypes from 'prop-types';

import { ActionHintIcon } from '#/modules/commonComponents/hint';

/** 對齊共用 ActionHintIcon：按鈕內 ? 說明（桌面 Tooltip／觸控 Popover） */
function WorkOrderOutboundActionHintIcon({ tip, ariaLabel, tone = 'default' }) {
  return (
    <ActionHintIcon
      tip={tip}
      ariaLabel={ariaLabel}
      tone={tone}
    />
  );
}

WorkOrderOutboundActionHintIcon.propTypes = {
  tip: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
  tone: PropTypes.oneOf(['default', 'inherit']),
};

export default WorkOrderOutboundActionHintIcon;
